import { createSelector } from 'reselect';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { dialerTypes } from 'modules/common/constants/conversationInitiatorTypes';
import {
  isCurrentConversationSIP,
  isConversationParticipant,
  currentConversationStatus,
  isCurrentUserConversationCreator,
  currentConversation as getCurrentConversation,
} from 'modules/appointmentInfo/selectors/currentAppointment';

import {
  CREATED,
  PENDING,
  CONNECTING,
  IN_PROGRESS,
  inProgressConversationStatuses,
} from 'modules/common/constants/conversationStatuses';

export const conferenceStarting = (state) =>
  currentConversationStatus(state) === CONNECTING
  || state.conference.consultationInfo.startConsultationRequestStatus === requestsStatuses.pending
  || state.conference.consultationInfo.startConsultationRequestStatus === requestsStatuses.success;

export const conferenceStopping = state =>
  state.conference.consultationInfo.stopConsultationRequestStatus === requestsStatuses.pending;

export const isInWaitingRoom = createSelector(
  getCurrentConversation,
  currentConversationStatus,
  (currentConversation, currentConversationStatus) =>
    [CREATED, PENDING].includes(currentConversationStatus) && dialerTypes.includes(currentConversation.initiator),
);

export const isNeedToShowLocalVideo = state =>
  isConversationParticipant(state) &&
  (([CONNECTING, IN_PROGRESS, CREATED].includes(currentConversationStatus(state))
    && !conferenceStopping(state))
    || conferenceStarting(state));

export const conferenceInProgress = createSelector(
  isConversationParticipant,
  isCurrentConversationSIP,
  isCurrentUserConversationCreator,
  currentConversationStatus,
  conferenceStopping,
  conferenceStarting,
  (isConversationParticipant, isCurrentConversationSIP, isCurrentUserConversationCreator, currentConversationStatus, conferenceStopping, conferenceStarting) =>
    isConversationParticipant &&
    !isCurrentConversationSIP &&
    (
      inProgressConversationStatuses.includes(currentConversationStatus)
      || (isCurrentUserConversationCreator && currentConversationStatus === CREATED)
      || conferenceStopping || conferenceStarting
    ),
);

export const conferenceInProgressWithSIP = createSelector(
  isConversationParticipant,
  currentConversationStatus,
  conferenceStopping,
  conferenceStarting,
  (isConversationParticipant, currentConversationStatus, conferenceStopping, conferenceStarting) =>
    isConversationParticipant &&
    (
      inProgressConversationStatuses.includes(currentConversationStatus)
      || [CREATED, PENDING].includes(currentConversationStatus)
      || conferenceStopping || conferenceStarting
    ),
);
